import React from 'react';
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 7,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#D9D9D9',
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#2CB00B',
    ...theme.applyStyles('dark', {
      backgroundColor: '#308fe8',
    }),
  },
}));

const BorderLinearProgressWithLabel = ({ value }) => {
  return (
    <div className="px-4 pt-2">
      <Box display="flex" alignItems="center" justifyContent="center" width="100%">
        <Box width="100%" mr={1}>
          <BorderLinearProgress variant="determinate" value={value} />
        </Box>
        <Box minWidth={35} display="flex" alignItems="center" justifyContent="center" flexShrink={0}>
          <Typography
            variant="body2"
            color="textSecondary"
          >{`${Math.round(value === 1 ? 0 : value)}% Completed`}</Typography>
        </Box>
      </Box>
    </div>
  );
};

export default BorderLinearProgressWithLabel;
